import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import './EventRegisterFormFieldWrapper.sass';

export const EventRegisterFormFieldWrapper = ({ className, children }) => {
  const classes = classnames('event-register-form-field-wrapper', {
    [`${className}`]: !!className,
  });
  return <div className={classes}>{children}</div>;
};

EventRegisterFormFieldWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

EventRegisterFormFieldWrapper.defaultProps = {
  className: '',
};
